import React, { useContext, useState , useEffect} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { AddressStandardizationService } from 'twia-capability-addressstandardization';
import { AddressStandardizationServiceCC } from 'twia-capability-fnol-addressstandardization';
import StandardizeAddressPopUp from "ent-capability-quoteandbind-common-react/components/StandardizeAddressPopUp/StandardizeAddressPopUp";
import { useModal } from '@jutro/components';
import addressControl from '../../util/addressControl';
import messages from '../../addressMessages.messages';
import metadata from './TWIAStandardizeButton.metadata.json5';
import styles from './StandardizeButton.scss';

function TWIAStandardizeButton(props) {
    const { showModal } = useModal();
    const { primaryAddressVM, authHeader, companyType, updatePrimaryAddressVM, isStandardizationDisabled, xPortal, standardizationResponse, zipCodevalidationMsg } = props;
    const [ address, setAddress ] = useState(primaryAddressVM);
    const [ isAddressValid, setIsAddressValid ] = useState(true);
    const translator = useContext(TranslatorContext);
    
    useEffect(() => {
        setAddress(primaryAddressVM);
    }, [primaryAddressVM]);
            
    const onStandardizeClick = async () => {
        if (
            !primaryAddressVM.addressLine1 ||
            !primaryAddressVM.city ||
            !primaryAddressVM.state ||
            !primaryAddressVM.postalCode || 
            zipCodevalidationMsg.length !== 0
        ) {
            setIsAddressValid(false);
        }
        else {
            try {
                if(xPortal !== 'CC'){
                    setIsAddressValid(true);
                    AddressStandardizationService.findStandardizedAddresses(address, authHeader).then(
                        async (theResult) => {
                            const componentProps = {
                                title: translator(messages.standardizeAddressDetails),
                                addressVM: address,
                                addressData: theResult,
                                authHeader
                            };
                            const propsToSend = {...componentProps, updatePrimaryAddressVM, companyType, xPortal};
                            
                            const result = await showModal(
                                <StandardizeAddressPopUp {...propsToSend} />
                            );
                            if(_.get(result, 'plus4CodeExt') === '14ND') {
                                _.set(theResult, 'noAddressMatchFound', true);
                                _.set(theResult, 'isSingleAddress', false);
                            }
                            primaryAddressVM.addressStandResult = theResult;
                            standardizationResponse(theResult); //DE17215
                            return result;
                        }
                    )
                } else {
                    setIsAddressValid(true);
                    AddressStandardizationServiceCC.findStandardizedAddressesCC(address, authHeader).then(
                        async (theResult) => {
                            const componentProps = {
                                title: translator(messages.standardizeAddressDetails),
                                addressVM: address,
                                addressData: theResult,
                                authHeader
                            };
                            const propsToSend = {...componentProps, updatePrimaryAddressVM, companyType, xPortal};
                            
                            const result = await showModal(
                                <StandardizeAddressPopUp {...propsToSend} />
                            );
                            primaryAddressVM.addressStandResult = theResult;
                            standardizationResponse(theResult); //DE17215
                            return result;
                        }
                    )
                }
            } catch(error) {
                console.error(`Error: ${erred}`);
            }
        }
    };

    const overrideProps = {
        standardizeAddressButton: {
            onClick:  onStandardizeClick,
            disabled: !addressControl.isStdBtnAvailable(address, xPortal) || isStandardizationDisabled,
            visible: addressControl.isStdSvcAvailable(address)
        },
        validationCheck: {
            visible: !isAddressValid
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

export default TWIAStandardizeButton;
